import { useQuery } from '@tanstack/react-query'
import { getBlock } from '../api'

export const blockDetailQueryKey = (id: string) =>
  ['blocks', 'detail', id] as const

export function useBlockDetail(id: string | undefined) {
  return useQuery({
    queryKey: ['blocks', 'detail', id ?? ''] as const,
    queryFn: () => getBlock(id!),
    enabled: id !== undefined && id !== '',
    staleTime: 15_000,
  })
}
